import classNames from 'classnames/bind';
import styles from './ActivityPanel.module.css';
import { BarGraphData } from '../../../types/dashboard';
import PanelContainer from './PanelContainer';
import PanelHeader from './PanelHeader';
import {
  CASES,
  LEARNING_TOOL_LABELS,
  LEARNING_WITH_SELPUB_VIEWER,
  LEARNING_TOOL_TEXT,
  LEARNING_CONTENT_TEXT,
  MOST_USED,
  STUDENTS_COUNT,
} from '../../../constants';
import { TooltipWrapper } from '../../Tooltip';
import { isMobile } from '../../../utils/util';

interface HorizontalBarPanelProps {
  cardId: string;
  title: string;
  data: BarGraphData[];
  totalCount?: number;
  topItemName?: string;
  nameLabels?: Record<string, string>;
  studentCount?: number;
  isOpen: boolean;
  onClose: () => void;
}

export default function HorizontalBarPanel({
  cardId,
  title,
  data,
  totalCount,
  topItemName,
  nameLabels,
  studentCount,
  isOpen,
  onClose,
}: HorizontalBarPanelProps) {
  const cx = classNames.bind(styles);

  const getDisplayName = (name: string) => {
    if (nameLabels) {
      return nameLabels[name] || name;
    }
    return LEARNING_TOOL_LABELS[name] || name;
  };

  const displayTopItemName = topItemName ? getDisplayName(topItemName) : '';

  const dataWithPercentage = data.map((item) => ({
    ...item,
    percentage:
      totalCount && totalCount > 0 ? (item.value / totalCount) * 100 : 0,
  }));

  return (
    <PanelContainer isOpen={isOpen}>
      <PanelHeader cardId={cardId} title={title} onClose={onClose} />
      <div className={cx('widget_content', 'graph_bar_h')}>
        {isMobile || (
          <ul className={cx('graph_list')}>
            {dataWithPercentage.map((item) => (
              <li
                key={item.rank}
                className={cx('graph_item', { first: item.rank === 1 })}
              >
                <div className={cx('graph_item_title')}>
                  <span className={cx('rank')}>{item.rank}</span>
                  <span className={cx('name')}>
                    {getDisplayName(item.name)}
                  </span>
                </div>
                <TooltipWrapper
                  content={`${item.value}${CASES} (${item.percentage.toFixed(
                    2
                  )}%)`}
                >
                  {(tooltipProps) => (
                    <div className={cx('bar_graph_wrap')} {...tooltipProps}>
                      <span
                        className={cx('bar_graph')}
                        style={
                          {
                            '--target-width': `${item.percentage}%`,
                          } as React.CSSProperties
                        }
                      />
                    </div>
                  )}
                </TooltipWrapper>
              </li>
            ))}
          </ul>
        )}
        {displayTopItemName && (
          <div className={cx('tool_info')}>
            <p className={cx('subtext')}>
              {studentCount === undefined
                ? LEARNING_WITH_SELPUB_VIEWER
                : STUDENTS_COUNT.replace('{count}', studentCount.toString())}
            </p>
            <p className={cx('tool_info_desc')}>
              <span className={cx('strong_tool')}>{displayTopItemName}</span>{' '}
              {title.includes('도구')
                ? LEARNING_TOOL_TEXT
                : LEARNING_CONTENT_TEXT}
            </p>
            <p className={cx('tool_info_desc')}>{MOST_USED}</p>
          </div>
        )}
      </div>
    </PanelContainer>
  );
}
